import actionCreator from 'helpers/actionCreator'
import { UPDATE_UI, UPDATE_UNIT, CHECK_LOCATION_SEARCH } from 'actions/uiActionTypes'

/** Called as an action when a ui value is changed */
export const updateUiAction = actionCreator(UPDATE_UI, 'updates')

/** Called as an action when unit of measurement is changed */
export const updateUnitAction = actionCreator(UPDATE_UNIT, 'isImperial')

/** Called as an action when location search completes */
export const checkLocationSearchAction = actionCreator(CHECK_LOCATION_SEARCH)



// WEBPACK FOOTER //
// ./src/actions/uiActions.js